export default __webpack_public_path__ + "static/char-s-21-zh-Hans-f90d8b424ad0e632fc4f622517050244.webp";